import styled, { css } from 'styled-components';
import Select from 'react-select';
import { ReactComponent as StyledLeftArrowIcon } from '../../../../../../assets/img/go-arrow-left.svg';
import { ReactComponent as WandSparklesIcon } from '../../../../../../assets/img/wand-sparkles.svg';
import { StyledSectionContainer } from '../../../../../../globalStyled';
import { fontDisplay, fontUi } from '../../../../../../theme/typography';
import { themedSelectMenuCss } from '../../../../../../theme/selectStyles';

const inkOnAccent = (hex) => {
  const raw = String(hex || '').replace('#', '');
  const full =
    raw.length === 3
      ? raw
          .split('')
          .map((char) => char + char)
          .join('')
      : raw;
  const value = parseInt(full, 16);
  if (!Number.isFinite(value)) return '#06170D';
  const channel = (shift) => {
    const n = ((value >> shift) & 255) / 255;
    return n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4;
  };
  const luminance =
    0.2126 * channel(16) + 0.7152 * channel(8) + 0.0722 * channel(0);
  return luminance > 0.55 ? '#06170D' : '#ffffff';
};

export const StyledTitle = styled.h3``;
export const StyledLeftArrow = styled(StyledLeftArrowIcon)`
  color: ${({ theme }) => theme.text};
  path,
  g {
    fill: currentColor;
    stroke: currentColor;
  }
`;

export const StyledWrapper = styled.section`
  /* margin-top: 36px; */
  /* flex: 3; */
  /* margin-right: 10px; */
  z-index: 1;
  h3 {
    ${fontDisplay};
    font-size: 18px;
    line-height: 1.2;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.text};
  }
  @media screen and (max-width: 768px) {
    margin: 0;
  }
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 280px;
  justify-content: flex-start;
  margin-bottom: 10px;
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
  @media screen and (min-width: 1200px) and (max-width: 1300px) {
    max-width: 220px;
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  padding: 10px;
  border-radius: 6px;
`;

export const StyledBlockWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

export const StyledContainer = styled(StyledSectionContainer)`
  flex-wrap: wrap;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: fit-content;
  padding-bottom: 10px;
  h3 {
    ${fontDisplay};
    width: 100%;
    font-size: 16px;
    line-height: 1.2;
    letter-spacing: -0.02em;
    border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
    padding: 10px 20px;
    color: ${({ theme }) => theme.text};
  }
`;
export const StyledTacticContainer = styled(StyledContainer)`
  z-index: 2;
`;

export const StyledChrisWandButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 4px 0 0 20px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: ${({ theme }) => theme.headerAccent || theme.accent};
  color: ${({ theme }) => inkOnAccent(theme.headerAccent || theme.accent)};
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  &:disabled {
    opacity: 0.55;
    cursor: default;
  }
  &:hover:not(:disabled) {
    opacity: 0.88;
  }
  @media screen and (max-width: 768px) {
    margin: 8px 0 0 15px;
  }
`;

export const StyledChrisWandIcon = styled(WandSparklesIcon)`
  width: 18px;
  height: 18px;
  display: block;
  color: inherit;
`;

export const StyledButton = styled.button`
  display: flex;
  /* flex: 1 40%; */
  width: 30%;
  flex-wrap: wrap;
  justify-content: center;
  /* width: 100%; */
  padding: 12px 5px;
  background: ${({ theme }) => theme.card};
  height: 90px;
  border: 1px solid ${({ theme }) => theme.border};
  box-shadow: none;
  border-radius: 6px;
  transition: all 0.3s;
  outline: none;
  margin: 5px 0;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    height: 120px;
  }
  svg {
    g {
      fill: ${({ theme }) => theme.textFaint};
      opacity: 1;
    }
  }
  ${({ active, theme }) => {
    if (active)
      return css`
        &.${active} {
          pointer-events: none;
          background: ${theme.text};
          box-shadow: none;
          border-radius: 6px;
          border: 1px solid ${theme.text};
          > span {
            color: ${theme.page};
          }
          svg {
            g {
              fill: ${theme.page};
              opacity: 1;
            }
          }
        }
      `;
  }}
  > span {
    ${fontUi};
    display: flex;
    justify-content: center;
    width: 100%;
    font-weight: 500;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: ${({ theme }) => theme.textFaint};
    transition: all 0.3s;
    @media only screen and (max-width: 1400px) {
      font-size: 12px;
    }
    svg {
      transition: all 0.3s;

      transform: rotate(180deg);
    }
  }
`;

export const StyledSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  margin-bottom: 20px;

  .react-select__control {
    height: 40px;
    color: ${({ theme }) => theme.text};
    background: ${({ theme }) => theme.card};
    border: 1px solid ${({ theme }) => theme.border};
  }
  .react-select__single-value {
    color: ${({ theme }) => theme.text};
  }
  .react-select__indicator-separator {
    display: none;
  }

  .react-select__placeholder {
    ${fontUi};
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.textFaint};
  }
  ${themedSelectMenuCss}
`;

export const StyledFormationButtons = styled.div`
  padding: 15px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  @media only screen and (max-width: 1400px) {
    padding: 15px 10px;
  }
`;

export const StyledIconPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  height: 60px;
  justify-content: center;
  align-items: center;

  @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    height: 40px;
  }
  @media only screen and (max-width: 1400px) {
    svg {
      height: 40px;
      max-width: 40px;
    }
  }
`;

export const StyledMobileSidebar = styled.div`
  height: 100%;
  width: 0px;
  position: fixed;

  z-index: 11;
  top: ${({ theme }) => theme.headerHeight};
  left: 0px;
  background: ${({ theme }) => theme.page};
  padding-top: 0px;
  transition: all 0.2s ease 0s;
  overflow: auto;
  padding-bottom: 10px !important;
  h3 {
    ${fontDisplay};
    margin-left: 15px;
    height: 46px;
    background-color: ${({ theme }) => theme.page};
    color: ${({ theme }) => theme.text};
    font-size: 15px;
    display: flex;
    align-items: center;
    flex-direction: row;
    @media only screen and (max-width: 768px) {
      margin-left: 0px;
      padding-left: 15px;
      border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
    }
    svg {
      margin-right: 20px;
    }
  }
  ${({ isOpened }) => {
    if (isOpened) {
      return css`
        width: 100%;

        //padding: 34px 24px 0 17px;
      `;
    }
  }}
`;
